import routeTypes from './route-types'

const ErrorLogListView = (r) => require.ensure([], () => r(require('./ErrorLogListView.vue')), 'errorloglist-chunk')
const ErrorLogDetail = (r) => require.ensure([], () => r(require('./ErrorLogDetail.vue')), 'errorlog-chunk')

export default [
  {
    path: routeTypes.ErrorLogListView.path,
    name: routeTypes.ErrorLogListView.name,
    component: ErrorLogListView,
    meta: {
      title: 'View Error'
    }
  },
  {
    path: routeTypes.ErrorLogDetail.path,
    name: routeTypes.ErrorLogDetail.name,
    component: ErrorLogDetail
  }
]
